export enum UserType {
  GRCOwner = 'GRC_owner',
  Collaborator = 'collaborator',
  Approver = 'approver',
  Free = 'free',
}
